"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteCaptchaService = void 0;
var captcha_service_1 = require("./captcha.service");
Object.defineProperty(exports, "authSuiteCaptchaService", { enumerable: true, get: function () { return captcha_service_1.authSuiteCaptchaService; } });
